import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { validateEmail } from '../../utils/emailRegex';
import { CoreService } from 'src/modules/core/services';
import { UserService } from '../../services';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  CommonServices,
  SharedValidators,
  AppFilter,
} from 'src/modules/shared';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class ForgotPasswordComponent implements OnDestroy {
  isRecaptcha: boolean;
  captcha: string;
  // forms status
  resetControlSuccess: boolean;
  resetControlRequired: boolean;

  forgotFormSuccess: boolean;
  forgotFormError: boolean;

  resetFormSuccess: boolean;
  resetFormError: boolean;

  formSubmitAttempt: boolean;

  // forms display
  simple: boolean = true;
  extreme: boolean;
  relaxed: boolean;
  showErrorForm: boolean;

  //global pendng
  pending: boolean;
  success: boolean;
  error: any;

  //forms
  resetControl = new FormControl('');
  forgotForm: FormGroup;
  resetForm: FormGroup;

  token: any;
  userData: any;

  // emailDisable: string;
  emailField: string;
  userNameField: string;

  //report Erro thins
  errorPending: boolean;
  errorStructure: any;
  errorPayload: any;
  errorFormError: any;
  errorSubmitSuccess: any;

  //dynamic tins
  prbs: any[];
  company_type: any[];
  actual_company_type: any[];
  ownershipType = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
    ],
  };

  companyType = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'company_type',
      },
    ],
  };

  private unsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private coreService: CoreService
  ) {
    this.forgotForm = this.fb.group({
      rc_number: ['', Validators.required],
      companyName: ['', Validators.required],
      tin_number: ['', Validators.required],
      username: ['', [Validators.required]],
      email: ['', [Validators.required]],
      // recaptcha: ["", [Validators.required]]
    });

    this.resetForm = this.fb.group(
      {
        password: [
          '',
          [
            Validators.required,
            SharedValidators.strongPassword,
            Validators.minLength(6),
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            SharedValidators.strongPassword,
            Validators.minLength(6),
          ],
        ],
        captcha: ['', [Validators.required]],
      },
      {
        validator: SharedValidators.matchingPasswords(
          'password',
          'confirmPassword'
        ),
      }
    );

    this.getCompanyType();
    this.getOwnerShip();
  }

  isFieldValid(field: string) {
    return (
      (!this.forgotForm.get(field).valid &&
        this.forgotForm.get(field).touched) ||
      (this.forgotForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  isFieldRValid(field: string) {
    return (
      (!this.resetForm.get(field).valid && this.resetForm.get(field).touched) ||
      (this.resetForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldRCss(field: string) {
    return {
      error: this.isFieldRValid(field),
    };
  }

  fieldCheckerModel(value) {
    if (validateEmail(value)) {
      this.emailField = value;
    } else {
      this.userNameField = value;
    }
  }

  setRecaptcha(value) {
    this.isRecaptcha = true;
    this.captcha = value;
  }

  //generic username/contractor id method
  submitReset() {
    this.error = false;
    this.resetControlSuccess = false;
    this.resetControlRequired = false;
    if (this.resetControl.value !== '') {
      this.pending = true;
      // this.emailDisable = this.resetControl.value;
      this.fieldCheckerModel(this.resetControl.value);
      this.userService
        .forgotPassword({
          email: this.resetControl.value,
          captcha: this.captcha,
          body: { email: this.resetControl.value, captcha: this.captcha },
        })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            this.resetControlSuccess = true;
            this.pending = false;
          },
          (error) => {
            this.pending = false;
            switch (error['status']) {
              case 200:
                this.resetControlSuccess = true;
                break;
              case 440:
                this.error =
                  'Sorry, the email or username you provided cannot be found. Please enter a valid email or username in order to recover your account';
                break;
              case 404:
                this.error =
                  'Sorry, the email or username you provided cannot be found. Please enter a valid email or username in order to recover your account';
                break;
              case 400:
                if (error.error['errorCode'] === 200220) {
                  this.simple = false;
                  this.extreme = true;
                } else if (error.error['errorCode'] === 200221) {
                  this.simple = false;
                  this.extreme = true;
                }
                break;
            }
          }
        );
    } else {
      this.pending = false;
      // this.isRecaptcha = true;
      this.resetControlRequired = true;
    }
  }

  //old contractors submit
  submit() {
    this.error = false;
    this.formSubmitAttempt = false;
    this.forgotFormSuccess = false;
    this.forgotFormError = false;
    if (this.forgotForm.valid) {
      this.pending = true;
      this.userService
        .validateForgotPassword({ body: this.forgotForm.value })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            this.pending = false;
            console.log('in success', res);
            this.userData = res;
            if (res['validationStatus']) {
              this.extreme = false;
              this.relaxed = true;
              this.forgotFormSuccess = true;
            }
          },
          (error) => {
            console.log('hello before');
            this.pending = false;
            this.forgotFormError = true;
            switch (error['status']) {
              case 200:
                this.resetControlSuccess = true;
                break;
              case 440:
                this.error =
                  'Sorry, the email or username you provided cannot be found. Please enter a valid email or username in order to recover your account';
                break;
              case 404:
                this.error =
                  'Sorry, the email or username you provided cannot be found. Please enter a valid email or username in order to recover your account';
                break;
              case 400:
                if (error.error['errorCode'] === 240425) {
                  console.log('hello');
                  this.forgotFormError = error.error['userMessage'];
                }
                break;
            }
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  //change password
  submitChange() {
    this.error = false;
    this.resetFormSuccess = false;
    this.resetFormError = false;
    if (this.resetForm.valid) {
      this.pending = true;
      this.userService
        .voneChangePassword({
          body: Object.assign({}, this.userData, this.resetForm.value),
        })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            this.pending = false;
            this.resetFormSuccess = true;
            // console.log("in success", res)
          },
          (error) => {
            // console.log("in error", error)
            this.pending = false;
            this.resetFormError = true;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  //get error structure
  showReport() {
    this.errorPending = true;
    let code = 880;
    this.coreService
      .getErrorStructure({ code: code })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.simple = false;
          this.extreme = false;
          this.relaxed = false;
          this.showErrorForm = true;
          this.errorPending = false;
          this.errorPayload = res;
          this.errorStructure = JSON.parse(res['complaintStructure']).structure;
          // console.log(this.errorStructure )
          //  console.log(this.company_type )
        },
        (error) => {
          this.errorFormError =
            'There seem to be a server error, please try again later';
        }
      );
  }

  submitErrorReport(res) {
    this.errorSubmitSuccess = false;
    this.errorPending = true;
    this.errorPayload['userProvidedData'] = JSON.stringify(res);
    this.errorPayload['comment'] = res.comment;
    this.errorPayload['complaintProcessType'] =
      this.errorPayload['processType'];
    this.coreService
      .submitComplaint({ body: this.errorPayload })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.showErrorForm = false;
          this.errorPending = false;
          this.errorSubmitSuccess = true;
        },
        (error) => {
          this.errorPending = false;
          this.errorFormError =
            'There seem to be a server error, please try again later';
        }
      );
  }

  getOwnerShip() {
    let para = new AppFilter({ sidx: '' });
    this.coreService
      .getOptions({ filter: JSON.stringify(this.ownershipType) })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.actual_company_type = res['rows'];
      });
  }
  getCompanyType() {
    let para = new AppFilter({ sidx: '' });
    this.coreService
      .getOptions({ filter: JSON.stringify(this.companyType) })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.company_type = res['rows'];
      });
  }
  // getPrb() {
  //   let para = new AppFilter({ sidx: "" })
  //   this.coreService.getPrb().pipe(
  //     takeUntil(this.unsubscribe$)
  //   ).subscribe(res => {
  //     this.prbs = res["rows"]
  //   })
  // }

  ngOnDestroy() {
    // unsubscribe all subsciptons
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
